<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>Opret sortlistet område</h1>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>
<div mat-dialog-content>
  <form [formGroup]="form" autocomplete="off">
    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Sortlistet postnummer</mat-label>
        <input formControlName="areaBlacklistZip" matInput />
      </mat-form-field>
    </div>
    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Sortlistet område</mat-label>
        <input formControlName="areaBlacklistPlaceName" matInput />
      </mat-form-field>
    </div>
  </form>
</div>

<div mat-dialog-actions>
  <button mat-raised-button mat-dialog-close="">Fortryd</button>
  <button [disabled]="!form.valid" mat-raised-button color="primary" (click)="create()">Opret</button>
</div>
